// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"inputs-module--checkbox--2uKTL","select":"inputs-module--select--3Q2xq","text":"inputs-module--text--bAFxd","error":"inputs-module--error--32aum"};